import { getChannelMetadataFromControlUnitState } from '../../../controlUnit/selectors/events';
import { ShowLevelOption } from '../../../groups/selectors/getLevelOfView';
import { getTranslateManyDevicesFunction } from '../../../CUTranslation/api/util/getTranslateFunction';
import { Sensordata, SensordataSTChartLine } from '../monitoring.model';
import { getLabelName, getTranslationNameByData } from './getLabelName';
import {
  getPreferredUnit,
  getValueWithPreferredUnitAndRounded,
} from '../../../controlUnit/api/util/sensor/formatValues';
import { Dictionary } from '@reduxjs/toolkit';
import { DeviceControlUnitsAPIResponse } from '../../../commander/api/device.model';

export function mapSensordataToSTChartLine(
  sensordata: Sensordata,
  deviceId: string,
  deviceName: string,
  CUsTranslate: ReturnType<typeof getTranslateManyDevicesFunction>,
  showLevelOption: ShowLevelOption,
  controlUnitState: Dictionary<DeviceControlUnitsAPIResponse>,
  preferredTemperatureUnit: string
): SensordataSTChartLine {
  const { values, ...sensordataOtherData } = sensordata;
  const metadata = getChannelMetadataFromControlUnitState(
    controlUnitState[sensordata.controlunit],
    sensordata.channel
  );

  const unitIn = metadata?.unitString ?? metadata?.unit;
  // I should kee on eye on ui-modules
  const unit = unitIn
    ? unitIn
    : sensordata.unit === 'NON'
    ? ' '
    : sensordata.unit;

  const channelName = metadata?.name;
  const channelId = sensordata.channel;
  const controlUnitId = sensordata.controlunit;
  const unitOut = getPreferredUnit(unit, preferredTemperatureUnit) ?? ' ';
  const unitString =
    getPreferredUnit(metadata?.unitString, preferredTemperatureUnit) ?? ' ';

  return {
    ...sensordataOtherData,
    ...metadata,
    unit: unitOut,
    unitString,
    deviceId,
    deviceName,
    name: getLabelName(
      showLevelOption,
      getTranslationNameByData(
        channelName,
        channelId,
        CUsTranslate,
        deviceId,
        controlUnitId
      ),
      sensordata.controlunitName,
      deviceName
    ),
    data: values.map((value) => ({
      // Unix timestamp (seconds)
      timestamp: Math.floor(value.timestamp / 1000),
      val: getValueWithPreferredUnitAndRounded(
        value.value,
        metadata,
        preferredTemperatureUnit
      ),
    })),
  };
}
